module.exports = "/static/js/da6ffbcd884dad2256836c1ac7e228a1.png";